<div class="row row-sm add-form">
    <form autocomplete="off" class="p-0" novalidate [formGroup]="userForm ">
        <div class="col-lg-12 col-md-12">

            <div class="card custom-card">
                <div class="card-body">
                    <div >
                        <h3 class="main-content-label mb-1"><b>
                              User Master
                            </b></h3>
                        <p class="text-muted card-sub-title mb-0">
                            User Master
                        </p>
                    </div>
                    
                   
                    <div class="row clearfix">
                        <div class="col-sm-4">
                            <div class="form-group">
                                <div class="">
                                    <mat-form-field appearance="outline" class="example-full-width mt-4" >
                                        <mat-label>
                                            User Name
                                        </mat-label>
                                        <input required onkeydown="return (event.keyCode!=13);" class="color" type="text" maxlength="25"
                                            placeholder="User Name" formControlName="LoginName"
                                            matInput >
                                            <mat-error class="margin_tp"
                                            *ngIf="userForm.controls['LoginName'].touched && userForm.controls['LoginName'].errors?.pattern">
                                           Enter Valid Data.
                                              </mat-error>
                                              <mat-error class="margin_tp"
                                            *ngIf="userForm.controls['LoginName'].touched && userForm.controls['LoginName'].errors?.required">
                                           This Field Is Mandatory.
                                              </mat-error>
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-4">
                            <div class="form-group">
                                <div class="">
                                    <mat-form-field appearance="outline" class="example-full-width mt-4" >
                                        <mat-label>
                                            Login Email
                                        </mat-label>
                                        <input required onkeydown="return (event.keyCode!=13);"  class="color" type="text" maxlength="50"
                                            placeholder="Email" formControlName="LoginEmail" 
                                            matInput >
                                            <mat-error class="margin_tp"
                                            *ngIf="userForm.controls['LoginEmail'].touched && userForm.controls['LoginEmail'].errors?.pattern">
                                           Enter Valid Data.
                                              </mat-error>
                                              <mat-error class="margin_tp"
                                            *ngIf="userForm.controls['LoginEmail'].touched && userForm.controls['LoginEmail'].errors?.required">
                                           This Field Is Mandatory.
                                              </mat-error>
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                       
                        <div class="col-sm-12 align-right">
                            <button type="button"
                                class="btn btn-primary my-2 me-2  btn-icon-text floatright btn btn-raised g-bg-blush2"
                                (click)="saveUser()" >
                                    Save
                            </button>
                            

                        </div>
                    </div>
                    <hr>
                    <div class="table-responsive">
                        <table id="datatable" class="table table-striped table-bordered text-nowrap text-left">
                            <thead>
                                <tr>
                                
                                    <th  class="f600" width="20%">
                                        User Id
                                    </th>
                                    <th  class="f600" width="35%">
                                        User Name   
                                    </th>
                                    <th  class="f600" width="35%">
                                        Email
                                    </th>
                                    <!-- <th>Status</th>
                                    <th>Type</th> -->
                                    <th  class="f600 text-center" width="10%">
                                       Action </th>
                                </tr>
                            </thead>
                            <tbody id="table_data">
                                <tr *ngFor="let user of userData;">
                                
                                    <td>{{user.LoginId}} </td>
                                    <td> {{user.LoginFullName}}</td>
                                    <td>{{user.LoginName}} </td>
                                    <!-- <td><span class="label-light-primary">Cancelled </span></td>
                                    <td class="text-success">• Direct</td> -->
                                    <td class="text-center">  
                                         
                                        <a class="btn-floating" title="Edit" (click)="prepopulateData(user)">
                                            <i class="fa fa-edit"></i>
                                        </a>
                                        <!-- <a class="btn-floating" title="Delete" (click)="deletetown(town)">
                                            <i class="fas fa-trash"></i>
                                        </a> -->
                                        <!-- <a class="btn-floating" title="Delete" (click)="deletee('true',town)">

                                            <i class="fas fa-trash"></i>
                                        </a> -->
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                </div>
            </div>
        </div>
    </form>
</div>